import React, { useState, useEffect } from 'react';
import { Tabs } from "antd";
import { fetchArticles } from 'api/articleservice';
import ArticleDetailsCard from './ArticleDetailsCard';
import "../css/ActiveTabs.css"; // اضافه کردن فایل CSS سفارشی

const ArticleDetailsTab = ({tabNames,articleId}) => {
  const [articles, setArticles] = useState([]);
  const [activeKey, setActiveKey] = useState("1"); //default:details

  const onChange = (key) => {
    setActiveKey(key);
   // console.log(key) ;
  };


  return (
    <div>
      <Tabs 
        onChange={onChange} 
        type="card" 
        className="custom-tabs" // اضافه کردن کلاس سفارشی
        items={tabNames.map(tab => ({ label: tab.label, key: tab.key }))}
      />
    <ArticleDetailsCard articleId={articleId} activeTabKey={activeKey}/>
    </div>
  );
};

export default ArticleDetailsTab;
